export default "__VITE_ASSET__Bf4XF5cH__"